"use client";

import * as React from "react";

import { NavPlatform, NavSection } from "@/lib/shadcn/components/sidebar/nav-platform";
import kerosLogo from "@/staticfiles/KH-logo-01.png";
import { Sidebar, SidebarContent, SidebarHeader, SidebarRail } from "@/lib/shadcn/ui/sidebar";
import { cn } from "@/lib/shadcn/utils";
import { Link } from "react-router-dom";

interface AppSidebarProps {
    user: { name: string; email: string; avatar: string };
    sections: NavSection[];
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar> & AppSidebarProps) {
    return (
        <Sidebar className={" border-r border-slate-800 md:w-64 w-full"} collapsible="offcanvas" {...props}>
            <SidebarHeader>
                <div className="p-2">
                    <Link to="/" className="flex items-center justify-center w-full">
                        <img
                            src={kerosLogo}
                            alt="Keros Hospitality"
                            className={cn(
                                "md:h- w-auto transition-all duration-300",
                                "dark:invert", // Invert logo colors in dark mode if needed
                                "max-w-[200px] object-contain",
                            )}
                        />
                    </Link>
                </div>
            </SidebarHeader>
            <SidebarContent className="py-4">
                <NavPlatform sections={props.sections} />
            </SidebarContent>
            {/*<SidebarFooter className="border-t border-slate-800">*/}
            {/*    <NavUser user={props.user}/>*/}
            {/*</SidebarFooter>*/}
            <SidebarRail />
        </Sidebar>
    );
}
